import { createSlice } from "@reduxjs/toolkit";
import { fetchProductNewest} from "../actions/ProductsNewestAction";

const newestSlice = createSlice({
  name: "newest",
  initialState: {
    newest: [], 
    pagination: {}, 
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductNewest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProductNewest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.newest = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchProductNewest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default newestSlice.reducer;
